<template>
  <div style="height: 100%">
    <mu-paper style="position: relative; z-index: 99" class="searchReminder">
      <mu-list style="padding-top: 0; padding-bottom: 0">
        <mu-list-item disableRipple>
          <div slot="title">
            <span v-text="searchTerm"></span>
          </div>
          <div slot="after" v-if="!isLoading">
            <span v-text="results.length"></span> of <span v-text="options.total_results + ' ' + $t('message.labelFoods')"></span>
          </div>
          <mu-icon @click.native="goBack" slot="left" value="chevron_left"></mu-icon>
        </mu-list-item>
      </mu-list>
    </mu-paper>
    <div class="scrollable-area" id="resultScroller" style="height: 100%">
      <mu-flexbox v-if="isLoading" align="center" justify="center" style="height: 100%">
        <mu-flexbox-item align="center">
          <mu-circular-progress :size="24"></mu-circular-progress>
          <br/>
          <span v-text="$t('message.loadingText')"></span>
        </mu-flexbox-item>
      </mu-flexbox>
      <mu-list v-if="!isLoading && results.length === 0" class="oddEven">
        <mu-list-item
          :title="$t('message.labelFoodSearchResultsEmpty')"
        >
          <mu-icon slot="left" value="warning"/>
        </mu-list-item>
      </mu-list>
      <mu-list v-if="!isLoading && results.length >= 1" class="oddEven">
        <mu-list-item
          v-for="result, index in results"
          :key="'result-' + index"
          :describeText="result.food_description"
          disableRipple
          @click.native="selectFood(result)"
        >
          <div slot="title" v-text="result.food_name" v-once></div>
          <div slot="describe" v-text="result.food_description" v-once></div>
          <mu-icon slot="right" value="add_circle" v-once/>
        </mu-list-item>

        <div
          v-if="!isAppending && options.total_results > results.length"
          id="infinite-scroll-detector"
        ></div>
      </mu-list>
      <div align="center" v-if="isAppending" style="padding: 24px;">
        <mu-circular-progress
          :size="24"
        ></mu-circular-progress>
      </div>
    </div>
  </div>
</template>
<script>

  import FoodApi from '../../../api/Food'
  import ScrollManager from '../../../helpers/ScrollManager'

  let optionsDefault = {
    page_number: 0,
    max_results: 25,
    total_results: 0
  };

  export default {
    props: {
      title: {
        type: String,
        default: "Breakfast"
      },
      mealTypeId: {
        type: Number,
        default: 1
      },
      date: {
        type: Object
      },
      searchValue: {
        type: String,
        default: ""
      }
    },
    data()
    {
      return {
        searchTerm: "",
        isAppending: false,
        isLoading: true,
        options: optionsDefault,
        results: []
      }
    },
    mounted()
    {
      let self = this;
      self.mealTypeId = self.$route.query.mealTypeId;
      self.searchTerm = self.$route.query.q;
      self.getData();
      $(window).resize(function () {
        self.fixScrollHeight();
      });
      let scrollableElement = document.getElementById('resultScroller');
      scrollableElement.addEventListener('scroll', self.handleScroll);
    },
    methods: {
      selectFood: function selectFood(food) {
        let self = this;
        self.$router.push({
          name: 'FoodDiaryAdd',
          query: {
            foodId: food.food_id,
            mealTypeId: self.mealTypeId,
            date: self.$route.query.date
          },
          params: {
            title: self.title
          }
        })
      },
      fixScrollHeight: function fixScrollHeight() {
        let self = this;
        self.$nextTick(function () {
          let appBarHeight = $('.mu-appbar').outerHeight();
          let searchReminderHeight = $('.searchReminder').outerHeight();
          $('#resultScroller').attr('style', 'height:' + ($(window).innerHeight() - (appBarHeight + searchReminderHeight) - 8) + 'px;overflow-y:scroll');
        });
      },
      handleScroll: function () {
        let self = this;
        if (!self.isAppending) {
          if (ScrollManager.isElementInViewport(document.getElementById('infinite-scroll-detector'))) {
            self.loadMoreData();
          }
        }
      },
      goBack() {
        let self = this;
        self.$router.push({
          name: 'FoodDiarySearch',
          params: {
            title: self.title,
            mealTypeId: self.mealTypeId
          },
          query: {
            q: self.searchTerm,
            date: self.$route.query.date,
            mealTypeId: self.$route.query.mealTypeId
          }
        })
      },
      loadMoreData() {
        let self = this, page = self.options.page_number + 1;
        self.isAppending = true;
        FoodApi.searchFoods(self.searchTerm, page, self.options.max_results)
          .then(function (response) {
            self.options = response.data.options;
            self.results.push.apply(self.results, response.data.foods)
            self.isAppending = false;
          })
          .catch(function (error) {
            self.isAppending = false;
          });
      },
      getData() {
        let self = this;
        //self.isLoading = true;
        self.results = [];
        FoodApi.searchFoods(self.searchTerm, self.options.page_number, self.options.max_results)
          .then(function (response) {
            self.results = response.data.foods;
            self.options = response.data.options;
            self.isLoading = false;
            self.fixScrollHeight();
          })
          .catch(function (error) {
            self.isLoading = false;
            self.results = [];
            self.options = optionsDefault
          })
      }
    }
  }

</script>
<style>
  #food-diary-search-results {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 8px !important;
    padding-bottom: 0 !important;
    overflow: hidden;
  }

  #food-diary-search-results .mu-paper {
    margin-left: 8px;
    margin-right: 8px;
  }

  div#food-diary-search-results .mu-item .show-left {
    padding-left: 9px !important;
  }

  #food-diary-search-results .mu-item.show-left {
    padding-left: 56px;
  }
</style>



// WEBPACK FOOTER //
// SearchResults.vue?ecd8c68e